export const iconFontAwesomeDisasterCrisisCloudShowersHeavy = (
	<i className="fa-solid fa-cloud-showers-heavy"></i>
);
